module.exports = __webpack_public_path__ + "static/media/alfa_4.ccf36a5f.mp4";